import type { PredictionFormValues } from "@/features/prediction/model/form";
import type {
  PredictionKpis,
  PredictionPayload,
  PredictionRequest,
} from "@/features/prediction/model/types";

export const MAX_PREDICTION_HISTORY = 50;
export const PREDICTION_HISTORY_QUERY_KEY = ["prediction-history"] as const;
export type PredictionHistoryStatus = "running" | "completed" | "failed";

export interface PredictionHistorySummary {
  id: string;
  createdAt: number;
  elapsedMs: number;
  status?: PredictionHistoryStatus;
  currentStep?: string | null;
  errorMessage?: string | null;
  request: PredictionRequest;
  kpis: PredictionKpis;
}

export interface PredictionHistoryRecord extends PredictionHistorySummary {
  review?: PredictionFormValues;
  payload: PredictionPayload | null;
}
